import { useTranslation } from "react-i18next";

import type { BillingPaymentMethod } from "@/schemas/billing";
import { paymentMethodLabel } from "@/utils/billing";

/** "Visa •••• 4242" / "Chase •••• 6789" card, with the ACH-pending note. */
export function PaymentMethodSummary({
  paymentMethod,
  pending,
  action,
}: {
  paymentMethod: Pick<BillingPaymentMethod, "type" | "brand" | "last4">;
  pending?: boolean;
  action?: React.ReactNode;
}) {
  const { t } = useTranslation("billing");
  const label = paymentMethodLabel(paymentMethod, {
    card: t("paymentMethod.cardFallback"),
    bank: t("paymentMethod.bankFallback"),
  });
  return (
    <div className="rounded-md ring-1 ring-garnet/30 bg-white p-4 max-w-[420px] flex flex-col gap-2">
      <div className="flex flex-row items-start justify-between gap-4">
        <div>
          <div className="body-small text-gray-500">
            {paymentMethod.type === "card"
              ? t("paymentMethod.cardLabel")
              : t("paymentMethod.bankLabel")}
          </div>
          <div className="font-semibold">{label}</div>
        </div>
        {action}
      </div>
      {pending ? (
        <p className="body-small text-gray-600">
          {t("paymentMethod.pendingVerification")}
        </p>
      ) : null}
    </div>
  );
}
